
import React, { useContext, useEffect } from 'react';
import AppContext from '../context/app/appContext';
import InputRange from 'react-input-range';

import { getReleasedFrom, getReleasedTo } from '../context/selectors';

const FilterTime = ({ ident }) => {

  const appContext = useContext(AppContext);

  const from = getReleasedFrom(appContext);
  const to = getReleasedTo(appContext);
  const minValue = from;
  const maxValue = to;

  useEffect(() => {
    if (appContext.dateRange.min === 0) {
      appContext.setDateRange({ min: minValue, max: maxValue });
    }
  }, [minValue, maxValue]);


  if (appContext.dateRange.min === 0) {
    //appContext.setDateRange({ min: minValue, max: maxValue });
    return '';
  }

  const expandToggle = (event) => {
    if (event.type === 'click' || event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      appContext.toggleActiveFilter(ident);
    }
  }

  if (!from || !to || from === to) {
    return '';
  }


  return (
    <li className="filter-time">
      <a className={appContext.activeFilters.indexOf(ident) >= 0 ? 'trigger selected' : 'trigger'} onClick={(event) => expandToggle(event)} onKeyDown={(event) => expandToggle(event)} href="/explore">Time</a>
      <div className="expandable">
        <div className="input-range-wrap">
          <InputRange
            maxValue={maxValue}
            minValue={minValue}
            value={appContext.dateRange}
            onChange={value => appContext.setDateRange(value)}
          />
          <strong>{appContext.dateRange.min} - {appContext.dateRange.max}</strong>
        </div>
      </div>
    </li>
  );
}

export default FilterTime;